/**
 * Copyright (c) 2024 Epinics (PVT) LTD
 * All Rights Reserved.
 * <p>
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * <p>
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * <p>
 */
import React, { useEffect } from "react";
import styles from "./index.module.css";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { useDispatch } from "react-redux";

import { showSnackbar } from "../../../../../common/actions";

const NextBackButtons = ({
  step,
  setStep,
  handleOnClickStepOne,
  handleOnClickStepTwo,
  isValidFormStepOne,
  isValidFormStepTwo,
  isFormFilledStepOne,
  isFormFilledStepTwo,
  handleBusinessNameValidation,
}) => {
  const dispatch = useDispatch();

  const onClickHandlerNext = () => {
    if (step < 3) {
      if (step === 2) {
      } else {
        setStep(step + 1);
      }
    }
  };

  const onClickHandlerBack = () => {
    if (step === 3) {
      window.location.reload();
    }
    if (step > 1) {
      setStep(step - 1);
    }
  };

  return (
    <div className={styles.mainDiv}>
      <div className={styles.buttonDiv}>
        {step === 1 || step === 3 ? (
          <div className={styles.backButtonDisable}>
            <MdKeyboardArrowLeft /> BACK
          </div>
        ) : (
          <div
            onClick={() => {
              onClickHandlerBack();
            }}
            className={styles.backButton}
          >
            <MdKeyboardArrowLeft /> BACK
          </div>
        )}
        {step === 3 ? (
          <div className={styles.nextButtonDisable}>
            NEXT <MdKeyboardArrowRight />
          </div>
        ) : (
          <div
            onClick={async () => {
              if (step === 1) {
                handleOnClickStepOne();
                const response = await handleBusinessNameValidation();

                if (isValidFormStepOne && isFormFilledStepOne) {
                  if (response) {
                    onClickHandlerNext();
                  }
                } else {
                  dispatch(
                    showSnackbar({
                      type: "error",
                      msg: "Please fill all the required fields",
                    })
                  );
                }
              }
              if (step === 2) {
                handleOnClickStepTwo();
                if (isValidFormStepTwo && isFormFilledStepTwo) {
                  onClickHandlerNext();
                } else {
                  dispatch(
                    showSnackbar({
                      type: "error",
                      msg: "Please fill all the required fields",
                    })
                  );
                }
              }
            }}
            className={styles.nextButton}
          >
            NEXT <MdKeyboardArrowRight />
          </div>
        )}
      </div>
    </div>
  );
};

export default NextBackButtons;
